import { Component, Input } from "@angular/core";

@Component({
  selector: "oz-dfu-count-badge",
  templateUrl: "./dfu-count-badge.component.pug",
})
export class DfuCountBadgeComponent {
  @Input() count: number; // Number of updates per device (parent + child)
}
